import { render } from "./CorrectionItem.vue?vue&type=template&id=5867b0c4&scoped=true"
import script from "./CorrectionItem.vue?vue&type=script&lang=js"
export * from "./CorrectionItem.vue?vue&type=script&lang=js"

import "./CorrectionItem.vue?vue&type=style&index=0&id=5867b0c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5867b0c4"]])

export default __exports__